import { Section, SectionHeading } from '../ui/Section'
import Reveal, { RevealGroup, RevealItem } from '../ui/Reveal'
import { COMPANY } from '../../data/company'

export default function About() {
  const stack = [
    ['Languages', COMPANY.techCapabilities.languages],
    ['Frameworks', COMPANY.techCapabilities.frameworks],
    ['Infrastructure', COMPANY.techCapabilities.infrastructure],
  ]

  return (
    <Section id="about" tone="raised" atmosphere="left">
      <div className="grid gap-x-16 gap-y-8 xl:grid-cols-[minmax(0,26rem)_minmax(0,1fr)] xl:items-start">
        <SectionHeading eyebrow="The company" title="An engineering partner, accountable end to end" />
        <Reveal as="p" delay={0.1} className="max-w-2xl text-lg leading-relaxed text-ink-3 text-pretty 2xl:text-xl xl:pt-14">
          {COMPANY.description}
        </Reveal>
      </div>

      {/* Principles: three numbered columns under one rule. */}
      <RevealGroup each={0.08} className="rule-draw mt-16 grid gap-x-10 gap-y-10 pt-8 md:grid-cols-3 xl:gap-x-14">
        {COMPANY.values.map((v, i) => (
          <RevealItem key={v.title}>
            <span className="font-mono text-xs font-semibold tracking-[0.12em] text-primary">{String(i + 1).padStart(2, '0')}</span>
            <h3 className="mt-3 text-2xl font-bold text-ink">{v.title}</h3>
            <p className="mt-2 text-[15px] leading-relaxed text-ink-3">{v.description}</p>
          </RevealItem>
        ))}
      </RevealGroup>

      <div className="mt-16 grid gap-x-16 gap-y-12 lg:grid-cols-[1.2fr_1fr]">
        {/* How to engage: a ruled table, not cards. */}
        <div className="surface rounded-3xl p-6 md:p-8">
          <Reveal as="p" y={8} className="eyebrow">How we engage</Reveal>
          <RevealGroup as="dl" each={0.05} className="mt-5 divide-y divide-outline-variant">
            {COMPANY.engagements.map((e) => (
              <RevealItem key={e.title} className="grid gap-1 py-4 sm:grid-cols-[14rem_1fr] sm:gap-6">
                <dt className="font-semibold text-ink">{e.title}</dt>
                <dd className="text-[15px] leading-relaxed text-ink-3">{e.detail}</dd>
              </RevealItem>
            ))}
          </RevealGroup>
        </div>

        {/* The stack, grouped. */}
        <div className="surface rounded-3xl p-6 md:p-8">
          <Reveal as="p" y={8} className="eyebrow">Technology</Reveal>
          <RevealGroup as="dl" each={0.05} className="mt-5 divide-y divide-outline-variant">
            {stack.map(([label, items]) => (
              <RevealItem key={label} className="grid gap-1 py-4 sm:grid-cols-[9rem_1fr] sm:gap-6">
                <dt className="font-mono text-[11px] font-semibold uppercase tracking-[0.12em] text-ink-3 sm:pt-1">{label}</dt>
                <dd className="font-mono text-[14px] leading-relaxed text-ink-2">{items.join(' · ')}</dd>
              </RevealItem>
            ))}
          </RevealGroup>
        </div>
      </div>
    </Section>
  )
}
